import { apiPost } from '../../api'

export const save_survey = data =>
  apiPost({
    endpoint: 'stoplight/save_survey',
    data: data
  })
